export default __webpack_public_path__ + "static/melanie-haije-0e8dc604bc25f434c102bc6ef3f3e0f7.png";